import React, { useEffect, useState } from 'react';
import { Container, Typography, Grid, Card, CardContent, CardMedia, Button, Box, Paper } from '@mui/material';
import { api } from '../services/api';
import { Product } from '../types/Product';
import ImageSlider from '../components/ImageSlider';
import MarbleCategories from '../components/MarbleCategories';
import HeroSection from '../components/HeroSection';
import Testimonials from '../components/Testimonials';
import CallToAction from '../components/CallToAction';
import Features from '../components/Features';
import ShivayInfo from '../components/ShivayInfo';
import MarbleViewer3D from '../components/MarbleViewer3D';
import BestSellers from '../components/BestSellers';

const Home = () => {
  const [featuredProducts, setFeaturedProducts] = useState<Product[]>([]);
  const [allProducts, setAllProducts] = useState<Product[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);

  useEffect(() => {
    const loadProducts = async () => {
      try {
        const [featured, all] = await Promise.all([
          api.getFeaturedProducts(),
          api.getAllProducts()
        ]);
        setFeaturedProducts(featured);
        setAllProducts(all);
      } catch (error) {
        console.error('Error loading products:', error);
      }
    };

    loadProducts();
  }, []);

  const scrollToProductDetail = (product: Product) => {
    setSelectedProduct(product);
    setTimeout(() => {
      const element = document.getElementById('product-detail-section');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  return (
    <>
      {/* Hero Section */}
      <HeroSection />
      
      <Container maxWidth="lg" sx={{ mt: 3 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          Welcome to Shivay Stonex
        </Typography>
        {/* <Typography variant="h5" component="h2" gutterBottom align="center" color="textSecondary">
          Discover our exquisite collection of premium marbles
        </Typography> */}

        {/* Image Slider Component */}
        {/* <ImageSlider /> */}
        
        {/* 3D Marble Viewer Component */}
        <MarbleViewer3D />

{/* Marble Categories Component */}
<MarbleCategories />
        {/* Features Component */}
        <Features />

        {/* <Box sx={{ my: 6 }}>
          <Typography variant="h4" component="h2" gutterBottom align="center">
            Featured Products
          </Typography>
          <Grid container spacing={4}>
            {featuredProducts.map((product) => (
              <Grid item key={product.id} xs={12} sm={6} md={4}>
                <Card>
                  <CardMedia
                    component="img"
                    height="200"
                    image={product.imageUrl}
                    alt={product.name}
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="h3">
                      {product.name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {product.description}
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      sx={{ mt: 2 }}
                      onClick={() => scrollToProductDetail(product)}
                    >
                      View Details
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box> */}
      </Container>

      {/* Products Section */}
      <Box id="products-section" sx={{ py: 6, backgroundColor: 'background.default' }}>
        <Container maxWidth="lg">
        
          <Grid container spacing={4}>
            {allProducts.map((product) => (
              <Grid item key={product.id} xs={12} sm={6} md={4}>
                <Card>
                  <CardMedia
                    component="img"
                    height="200"
                    image={product.imageUrl}
                    alt={product.name}
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="h3">
                      {product.name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {product.description}
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      sx={{ mt: 2 }}
                      onClick={() => scrollToProductDetail(product)}
                    >
                      View Details
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Product Detail Section */}
      {selectedProduct && (
        <Box id="product-detail-section" sx={{ py: 6 }}>
          <Container maxWidth="lg">
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <img
                  src={selectedProduct.imageUrl}
                  alt={selectedProduct.name}
                  style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="h4" component="h1" gutterBottom>
                  {selectedProduct.name}
                </Typography>
                <Typography variant="body1" paragraph>
                  {selectedProduct.description}
                </Typography>
                
                <Paper sx={{ p: 2, mb: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="subtitle2" color="textSecondary">
                        Category
                      </Typography>
                      <Typography variant="body1">{selectedProduct.category}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="subtitle2" color="textSecondary">
                        Color
                      </Typography>
                      <Typography variant="body1">{selectedProduct.color}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="subtitle2" color="textSecondary">
                        Finish
                      </Typography>
                      <Typography variant="body1">{selectedProduct.finish}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="subtitle2" color="textSecondary">
                        Size
                      </Typography>
                      <Typography variant="body1">{selectedProduct.size}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="subtitle2" color="textSecondary">
                        Origin
                      </Typography>
                      <Typography variant="body1">{selectedProduct.origin}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="subtitle2" color="textSecondary">
                        Stock
                      </Typography>
                      <Typography variant="body1">{selectedProduct.stockQuantity} units</Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </Box>
      )}
      
      {/* Testimonials Component */}
      {/* <Testimonials /> */}
      
      {/* Shivay Stonex Information Component */}
      <ShivayInfo />
      
      {/* Call to Action Component */}
      <CallToAction />

      {/* <BestSellers /> */}
    </>
  );
};

export default Home; 